import { useUpdateDocumentTitle } from '@anytag/shared-hooks';

export const useYoutubeCMSDocumentTitle = () => {
  useUpdateDocumentTitle({
    title: 'YouTube Content Management System',
    appHeader: 'YouTube Content Management System'
  });
};
